// Package / source 進入點（admin ESM import 走這裡）。註冊
// <pulse-survey>（idempotent —— 一頁可能載入 IIFE 兩次）並再匯出 class。這裡刻意
// 不掃 DOM；自動掛載放在 embed.ts，避免 admin 預覽 import 時去掃宿主頁面。
import { PulseSurvey } from './survey-element'
import './events'

if (!customElements.get('pulse-survey'))
  customElements.define('pulse-survey', PulseSurvey)

export { PulseSurvey }

// property-fed 介面（surveyData / resultsData）是公開 API 的一部分；匯出對應型別，
// 讓 consumer（admin preview）不必再走 `as unknown as` cast。零 runtime 成本。
export type {
  Option,
  Question,
  QuestionType,
  ResultOption,
  ResultQuestion,
  SelectionLimit,
  SelectionLimitMode,
  SurveyContent,
  SurveyResult,
} from './contract'

export type { PulseEmptyDetail, PulseReadyDetail } from './events'
